import "../../sass/components/AmplifySpinner.scss";

export default function AmplifySpinner() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="amplify-spinner-svg" viewBox="0 0 64 64">
            <circle className="amplify-spinner-inner" cx="32" cy="32" r="20" fill="none" strokeWidth="3"></circle>
            <circle className="amplify-spinner-outer" cx="32" cy="32" r="30" fill="none" strokeWidth="3"></circle>
        </svg>
    )
}
